export default __webpack_public_path__ + "opcosante.2b89739.png";